import { useCallback, useRef, useState } from "react";
import { toast } from "sonner";

// Stato → colori, unica fonte per Ordini al banco, Lavorazioni e Ordini online.
// solid = bordo/colore pieno, fill = sfondo badge/pulsante con testo bianco (contrasto AA), bg = sfondo riga
const C = {
  red: { solid: "#DC2626", fill: "#DC2626", bg: "#FEE2E2" },
  orange: { solid: "#EA580C", fill: "#C2410C", bg: "#FFEDD5" },
  blue: { solid: "#2563EB", fill: "#2563EB", bg: "#DBEAFE" },
  violet: { solid: "#7C3AED", fill: "#7C3AED", bg: "#EDE9FE" },
  teal: { solid: "#0891B2", fill: "#0E7490", bg: "#CFFAFE" },
  green: { solid: "#16A34A", fill: "#15803D", bg: "#DCFCE7" },
  pink: { solid: "#DB2777", fill: "#BE185D", bg: "#FCE7F3" },
  gray: { solid: "#6B7280", fill: "#6B7280", bg: "#F3F4F6" },
};

export const STATE_COLORS = {
  // Ordini al banco: sospeso → lavorazione → completato
  sospeso: C.red, lavorazione: C.orange, completato: C.green,
  // Lavorazioni personalizzate: da_fare → in_lavorazione → pronto → ritirato
  da_fare: C.red, in_lavorazione: C.blue, pronto: C.violet, ritirato: C.green,
  // Ordini online: in_attesa_pagamento → ricevuto → pagato → in_produzione → spedito → completato
  in_attesa_pagamento: C.red, ricevuto: C.pink, pagato: C.orange, in_produzione: C.blue, spedito: C.teal,
  annullato: C.gray,
};

export const stc = (s) => STATE_COLORS[s] || C.gray;
export const rowStyle = (s) => ({ borderLeft: `6px solid ${stc(s).solid}`, backgroundColor: stc(s).bg });
export const fillStyle = (s) => ({ backgroundColor: stc(s).fill, color: "#fff" });

export function StatePill({ s, label, testid }) {
  return <span data-testid={testid} style={fillStyle(s)} className="inline-block whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-bold uppercase leading-none tracking-wide">{label}</span>;
}

// Effetti riga: flash al cambio stato, uscita animata al completamento
export function useRowFx() {
  const [flash, setFlash] = useState({});
  const [leaving, setLeaving] = useState({});
  const t = useRef({});
  const doFlash = useCallback((id) => {
    setFlash((f) => ({ ...f, [id]: (f[id] || 0) + 1 }));
    clearTimeout(t.current[id]);
    t.current[id] = setTimeout(() => setFlash((f) => { const x = { ...f }; delete x[id]; return x; }), 1100);
  }, []);
  const leave = useCallback((id, then) => {
    setLeaving((l) => ({ ...l, [id]: true }));
    setTimeout(() => { then(); setLeaving((l) => { const x = { ...l }; delete x[id]; return x; }); }, 380);
  }, []);
  const cls = (id) => `${leaving[id] ? "row-leave" : ""} ${flash[id] ? "row-flash" : ""}`;
  return { doFlash, leave, cls, flashKey: (id) => flash[id] || 0 };
}

export function undoToast(text, onUndo) {
  toast.success(text, { duration: 5000, action: { label: "Annulla", onClick: onUndo } });
}
